<template>
  <div v-if="appointment && appointment.car">
    <tab-title
      :car-id="appointment.car.id"
      text="出品者申告情報" />
    <v-text-field
      :label="labels['myPageStep']"
      :value="myPageStep"
      readonly
      disabled
      class="mb-3"
    />

    <cp-checkbox
      v-for="(item) in items"
      :key="item.id"
      :item="item"
      :data-label-scroll="item.fieldName"
      @update="updateSelfIns"
    />
    <v-divider class="my-5" />
    <v-btn
      outline
      color="info"
      block
      large
      to="evaluation#top">次へ</v-btn>
  </div>
</template>

<script>
import { GET_CAR_FIELDS, GET_CAR_ID_AND_STEP_INFO } from '../../queries';
import { labels, stepById, onOffByText } from '../../options';

export default {
  data() {
    return {
      labels,
      items: [
        {
          id: 1,
          name: 'otherNormalEquipment',
          fieldName: 'OTHER_NORMAL_EQUIPMENT',
          update: 'OTHER_NORMAL_EQUIPMENT_CHECKED',
          label: labels.otherNormalEquipment,
          value: '',
          checked: false,
        },
        {
          id: 2,
          name: 'otherFaultEquipment',
          fieldName: 'OTHER_FAULT_EQUIPMENT',
          update: 'OTHER_FAULT_EQUIPMENT_CHECKED',
          label: labels.otherFaultEquipment,
          value: '',
          checked: false,
        },
        {
          id: 3,
          name: 'otherDamages',
          fieldName: 'OTHER_DAMAGES',
          update: 'OTHER_DAMAGES_CHECKED',
          label: labels.otherDamages,
          value: '',
          checked: false,
        },
      ],
      myPageStep: '',
    };
  },
  apollo: {
    appointment: {
      query: GET_CAR_ID_AND_STEP_INFO,
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
      result({ data }) {
        this.carId = data.appointment.car.id;
        const { step } = data.appointment.clientCabinetWorkflow;
        this.myPageStep = stepById(step) ? stepById(step).value : '';
      },
    },
    carFields: {
      query: GET_CAR_FIELDS,
      fetchPolicy: 'network-only',
      skip() {
        return !this.appointment || !this.appointment.car.id;
      },
      variables() {
        return {
          carId: this.appointment.car.id,
        };
      },
      result({ data }) {
        const carFields = data.carFields.data.reduce(
          (acc, cur) => ({ ...acc, [cur.code]: cur.value }), {},
        );

        for (let i = 0; i < this.items.length; i += 1) {
          const item = this.items[i];
          item.value = this.isExist(carFields[item.fieldName]);
          if (this.isExist(carFields[item.update], false)) {
            item.checked = onOffByText(carFields[item.update]).value;
          }
        }
      },
    },
  },
  methods: {
    isExist(value, defaultValue = '') {
      return value || defaultValue;
    },
    getItemByName(name) {
      return this.items.find(s => s.name === name);
    },
    updateSelfIns(code, value) {
      return this.updateField({
        code,
        value,
        carId: this.appointment.car.id,
        typeId: 84,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/ConfirmForSelfInsTab.vue